import {
  AppContext,
  appContextInitialState,
  appContextReducer,
} from "./utils/appContext";
import React, { useReducer } from "react";
import { history, persistor, store } from "./redux/store";

import { BrowserRouter } from "react-router-dom";
import { OnlineStatusProvider } from "./contexts/OnlineStatusContext";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";
import Router from "./router";
import Toast from "./utils/Toast";

const App = () => {
  const [state, dispatch] = useReducer(
    appContextReducer,
    appContextInitialState
  );
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <AppContext.Provider value={{ state, dispatch }}>
          <BrowserRouter>
            <OnlineStatusProvider>
              <Router history={history} basename={process.env.PUBLIC_URL} />
              <Toast />
            </OnlineStatusProvider>
          </BrowserRouter>
        </AppContext.Provider>
      </PersistGate>
    </Provider>
  );
};

export default App;
